import styled, { css } from 'styled-components'

export const LeftContainer = styled.div`
  flex: 1;
`
export const RightContainer = styled.div`
  flex: 3;
  justify-content: flex-end;
  display: flex;
`

export const Description = styled.span`
  display: flex;
  align-items: center;
  min-height: 3rem;
`

export const Content = styled.div`
  display: flex;
  justify-content: end;
  gap: 1rem;
  align-items: baseline;

  // Supports gap for all browsers Safari verisions lower than 16
  ${Description} {
    .safari-lower-than-16 & {
      margin-right: 1rem;
    }
  }
`

export const LineItemSizeButton = styled.li<{
  disabled?: boolean
  state?: string
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.6rem;
  list-style-type: none;
  padding: 1rem 3rem;
  border-bottom: 1px solid
    ${({ theme }) => {
      return theme.colors.border
    }};
  margin: 0;

  &:first-child {
    border-top: 1px solid
      ${({ theme }) => {
        return theme.colors.border
      }};
  }

  ${({ theme, state }) => {
    if (state === 'loading') {
      return css`
        background: ${theme.colors.hover};
      `
    }
    if (state === 'success') {
      return css`
        background: ${theme.colors.primary};
      `
    }
    if (state === 'error') {
      return css`
        // SHOP-2063: add error message with toast
        background: #ef4444;
      `
    }

    return ''
  }}

  ${LeftContainer} {
    color: ${({ theme, disabled }) => {
      return disabled ? theme.colors.hover : theme.colors.text.primary
    }};

    ${({ theme, state }) => {
      // SHOP-2063: add error message with toast
      if (state === 'loading' || state === 'success' || state === 'error') {
        return css`
          color: ${theme.colors.text.secondary};
        `
      }

      return ''
    }}
  }

  ${RightContainer} {
    color: ${({ theme, disabled }) => {
      return disabled ? theme.colors.hover : theme.colors.text.primary
    }};

    ${({ theme, state }) => {
      // SHOP-2063: add error message with toast
      if (state === 'loading' || state === 'success' || state === 'error') {
        return css`
          color: ${theme.colors.text.secondary};
        `
      }

      return ''
    }}
  }
`
